module.exports = __webpack_public_path__ + "assets/img/bh3.4a4eed76.jpg";